import { Readable } from './Readable';
export function read(data) {
    return Readable.create(data).read();
}
//# sourceMappingURL=read.js.map